module.exports = __webpack_public_path__ + "assets/img/header.ec91faf3.jpg";